/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PagedModelRequest } from './pagedModelRequest';
import { PagedListMetaData } from './pagedListMetaData';
import { InsuranceCarrierDetailsViewModel } from './insuranceCarrierDetailsViewModel';

export interface InsuranceCarrierDetailsViewModelPagedModelResponse {
  pagedRequest?: PagedModelRequest;
  data?: Array<InsuranceCarrierDetailsViewModel> | null;
  metaData?: PagedListMetaData;
}
